import { TemplateConfig } from '../types';

export const twoChoiceConfig: TemplateConfig = {
  id: 'two-choice',
  name: '二选一',
  description: '分析两个选择的不同发展情况',
  cardCount: 5,
  
  fieldDefaults: {
    title: '二选一',
    customerQuestion: '**二选一，分别对应的情况**',
    cardPlaceholders: [
      '请输入第 3 行第 1 张牌',
      '请输入第 2 行第 1 张牌',
      '请输入第 2 行第 2 张牌',
      '请输入第 1 行第 1 张牌',
      '请输入第 1 行第 2 张牌'
    ],
    cardInfos: [
      '你自己现在的心态和现状',
      '假如你选左边选项的话，在短期之内你们会发展成什么情况',
      '假如你选右边选项的话，在短期之内你们会发展成什么情况',
      '假如你选左边选项的话，长期来看你们会发展成什么情况',
      '假如你选右边选项的话，长期来看你们会发展成什么情况'
    ]
  },
  
  disabledFields: ['title', 'customerQuestion', 'cardCount', 'cardInfos'],
  
  generateOptions: {
    normal: true,
    thinking: true
  },
  
  ui: {
    color: '#fa8c16',
    backgroundColor: '#fff7e6',
    icon: '⚖️'
  }
};